<template>
  <div class="flex flex-col gap-4 p-4 pb-10 flex-no-wrap flex-1 overflow-auto">
    <div class="flex justify-center items-center gap-4 col flex-no-wrap">
      <slot name="top" />
    </div>
    <div
      class="flex justify-center items-center gap-4 col flex-no-wrap"
      style="min-height: 140px"
    >
      <slot name="mid" />
    </div>
    <div
      class="bg- flex justify-center items-center gap-4 col flex-no-wrap flex-grow"
      style="min-height: 400px"
    >
      <slot name="bot" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.row {
  width: 100%;
  min-height: 300px;
}
</style>
